
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/privateAppsPanel/components/appDescription/appDescription.scss.css.virtualfile';
        module.exports = {"content":"_content_1006j_1","container":"_container_1006j_4"};